export default "__VITE_PUBLIC_ASSET__c31974d2__"